import React from 'react';

import {
	useMutation, useRefresh, useNotify,
	TextInput, FormWithRedirect, FieldTitle,
	required, number, minValue, useTranslate
} from 'react-admin';
import AddIcon from '@material-ui/icons/Add';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { PassProps } from '../../../../components/_helpers/PassProps';

import { NumberInputEx } from '../../../../components/inputs/NumberInputEx';
import { GridForm, GridInput } from '../../../../components/GridForm';
import { useSimpleModalToggle } from '../../../../components/dialogs/useSimpleModal';

import { useNotifyError } from '../../../../utils/notifiers/useNotifyError';

import { ArticleAutocompleteInputAdvanced } from './ArticleAutocompleteInput';
import { checkPriceEditable } from './_helper';



export const AddArticle = (props) => {
	const refresh = useRefresh();
	const notifyError = useNotifyError();
	const { open, handleOpen, handleClose } = useSimpleModalToggle();
	const [isPlriceEditable, setIsPlriceEditable] = React.useState(false);
	const translate = useTranslate()

	const [approve, { loading }] = useMutation({
        type: 'create',
        resource: 'order-pricelist',
    }, {
		onSuccess: () => {
			handleClose();
			refresh();
		},
		onFailure: (error) => {
			notifyError(error);
		}
	});

	const handleSubmit = (values) => {
		approve({
			payload: {
				// id: props.order.id,
				data: {
					order_id: props.order.id,
					...values,
				},
			}
		})
	}

	return (
		<div style={{ textAlign: "center" }}>
			<Button aria-label="delete" size="small" color="primary" variant="contained" startIcon={<AddIcon />} onClick={handleOpen}>
				{translate("resources.order-pricelist.button.add_article")}
			</Button>
			{open && <Dialog maxWidth="xs" open={open} onClose={handleClose}>
				<DialogTitle>{translate("resources.order-pricelist.button.add_article")}</DialogTitle>
				<FormWithRedirect
					submitOnEnter={false}
					component={DialogContent}
					save={handleSubmit}
					render={({ handleSubmitWithRedirect, form, record }) => (
						<React.Fragment>
							<PassProps component={DialogContent} childPropKeys={["resource"]} resource="order-pricelist">
								<GridForm>
									<GridInput xs={12} component={ArticleAutocompleteInputAdvanced} label={"resources.order-pricelist.fields.article_code"} source="article_code" validate={[required(translate("ra.validation.required"))]} 
										autoFocus terminal_id={props.order.terminal_id} company_id={props.order.company_id} onItemChange={item => {										
										form.change("service_description", item.service_description);
										form.change("price", item.price);
										form.change("units", 1);
										setIsPlriceEditable(checkPriceEditable(item.code));
									}} />
									<GridInput xs={12} component={TextInput} source="service_description" />									
									{isPlriceEditable && <GridInput xs={6} component={NumberInputEx} type="float" digitsCount={1} validate={[required(), number(), minValue(0)]} source="price" />}
									<GridInput xs={6} component={NumberInputEx} type="float" digitsCount={1} validate={[required(), number(), minValue(0.1)]} source="units" />
								</GridForm>
							</PassProps>
							<DialogActions>
								<Button disabled={loading} onClick={handleClose} color="primary">
									{translate("resources.order-pricelist.button.cancel")}
								</Button>
								<Button disabled={loading} onClick={handleSubmitWithRedirect} color="primary">
									{translate("resources.order-pricelist.button.add")}
								</Button>
							</DialogActions>
						</React.Fragment>
					)}
				/>
			</Dialog>}
		</div>
	);
};
